import { PROJECTS_SAVE_RESULT } from "../constants/projects-save-results.ts"
import type { PendingCommitment } from "./services.types.ts"

interface CommitmentsRefusal {
  type?: string
  pending_commitments?: PendingCommitment[]
}

/** The meetings a refused close would drop, or null for any other refusal. */
export const pendingCommitmentsFrom = (
  payload: unknown
): PendingCommitment[] | null => {
  const refusal = payload as CommitmentsRefusal | null | undefined
  if (refusal?.type !== PROJECTS_SAVE_RESULT.PENDING_COMMITMENTS) return null

  const listed = refusal.pending_commitments ?? []
  // An empty list leaves nothing to confirm, so it is an ordinary error.
  return listed.length ? listed : null
}

/** Checked before the handled-error path, so its toast never buries the question. */
export const rejectPendingCommitments = <R>(
  payload: unknown,
  rejectWithValue: (value: { pendingCommitments: PendingCommitment[] }) => R
): R | null => {
  const pendingCommitments = pendingCommitmentsFrom(payload)
  return pendingCommitments ? rejectWithValue({ pendingCommitments }) : null
}

/** The same list, read off a rejected thunk. */
export const commitmentsFromRejection = (
  error: unknown
): { pendingCommitments: PendingCommitment[] } | undefined => {
  const listed = (
    error as { pendingCommitments?: PendingCommitment[] } | undefined
  )?.pendingCommitments
  return listed?.length ? { pendingCommitments: listed } : undefined
}
